import script from "./BrainView.vue?vue&type=script&setup=true&lang=js"
export * from "./BrainView.vue?vue&type=script&setup=true&lang=js"

import "./BrainView.vue?vue&type=style&index=0&id=5630b564&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5630b564"]])

export default __exports__